export default __webpack_public_path__ + "6b2dce20cfbfb6666007070ac174bb48.png";